import {useTranslation} from "../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import {useCallback, useEffect, useState} from "react";
import * as yup from "../../__snowpack__/pkg/yup.js";
const requiredKey = "formRules.required";
export function useGetInput({
  inputRef
}) {
  const getInput = useCallback(() => {
    if (inputRef && "current" in inputRef) {
      return inputRef.current;
    }
    return inputRef;
  }, [inputRef]);
  const [input, setInput] = useState(getInput());
  useEffect(() => {
    setInput(getInput());
  }, [getInput]);
  return [input, setInput];
}
export function useInputRules() {
  const {
    t
  } = useTranslation();
  const required = useCallback((value, input) => input?.required && (yup.string().required().isValidSync(value) || t(requiredKey)), [t]);
  const email = useCallback((value, input) => {
    if (input?.type === "email" && value) {
      return yup.string().email().isValidSync(value) || t("formRules.email");
    }
    return void 0;
  }, [t]);
  const url = useCallback((value, input) => {
    if (input?.type === "url" && value) {
      return yup.string().url().isValidSync(value) || t("formRules.url");
    }
    return void 0;
  }, [t]);
  const pattern = useCallback((value, input) => {
    if (input?.pattern && value) {
      const regex = new RegExp(input?.pattern);
      return yup.string().matches(regex).isValidSync(value) || t("formRules.pattern");
    }
    return void 0;
  }, [t]);
  const minLength = useCallback((value, input) => input?.minLength !== void 0 && input?.minLength > 0 && (yup.string().min(input.minLength).isValidSync(value) || t("formRules.minlength", {
    minlength: input?.minLength
  })), [t]);
  const maxLength = useCallback((value, input) => input?.maxLength !== void 0 && input?.maxLength > 0 && (yup.string().max(input.maxLength).isValidSync(value) || t("formRules.maxlength", {
    maxlength: input?.maxLength
  })), [t]);
  return {
    required,
    email,
    url,
    pattern,
    maxLength,
    minLength
  };
}
export function useCheckboxRules() {
  const {
    t
  } = useTranslation();
  const required = useCallback((value, input) => input?.required && (yup.boolean().isTrue().isValidSync(value) || t(requiredKey)), [t]);
  return {
    required
  };
}
export function useRadioRules() {
  const {
    t
  } = useTranslation();
  const required = useCallback((value, input) => input?.required && (value || t(requiredKey)), [t]);
  return {
    required
  };
}
